import { motion } from 'framer-motion';

export default function PageHeader({ title, subtitle, icon: Icon, action }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="mb-6"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {Icon && (
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center">
              <Icon className="w-8 h-8 text-white" strokeWidth={2} />
            </div>
          )}
          <div>
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-900">{title}</h1>
            {subtitle && <p className="text-base sm:text-lg text-slate-600 mt-1">{subtitle}</p>}
          </div>
        </div>
        {action && <div>{action}</div>}
      </div>
    </motion.div>
  );
}
